import React, { useState, useMemo, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import TopBar from './components/TopBar';
import Footer from './components/Footer';
import PageWrapper from './components/PageWrapper';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ProductSearch from './pages/ProductSearch';
import ProductDetails from './pages/ProductDetails';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import RefundPolicy from './pages/RefundPolicy';
import { MetaProvider, useMeta } from './contexts/MetaContext';

function AppContent() {
  const { metaData } = useMeta();
  const [mode, setMode] = useState(metaData.theme?.mode || 'light');
  const [searchTerm, setSearchTerm] = useState('');

  // Update mode when metaData changes
  useEffect(() => {
    if (metaData.theme?.mode) {
      setMode(metaData.theme.mode);
    }
  }, [metaData]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          // primary: {
          //   main: '#222', // Changed to black
          // },
        },
      }),
    [mode],
  );

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <TopBar 
          storeName="My Store" 
          toggleTheme={toggleTheme} 
          mode={mode} 
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
        <Routes>
          <Route path="/" element={<PageWrapper><HomePage /></PageWrapper>} />
          <Route path="/search" element={<PageWrapper fullWidth><ProductSearch searchTerm={searchTerm} /></PageWrapper>} />
          <Route path="/product/:id" element={<PageWrapper fullWidth><ProductDetails /></PageWrapper>} />
          <Route path="/terms-of-service" element={<PageWrapper><TermsOfService /></PageWrapper>} />
          <Route path="/privacy-policy" element={<PageWrapper><PrivacyPolicy /></PageWrapper>} />
          <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
          <Route path="/refund-policy" element={<PageWrapper><RefundPolicy /></PageWrapper>} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <MetaProvider>
      <AppContent />
    </MetaProvider>
  );
}

export default App;